import { Conversation } from '../types';

const STORAGE_KEY = 'versetaille_conversations';

export const saveConversations = (conversations: Conversation[]): void => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(conversations));
};

export const getConversations = (): Conversation[] => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return [];

    try {
        return JSON.parse(stored);
    } catch (error) {
        console.error('Failed to parse stored conversations:', error);
        return [];
    }
};

export const saveCurrentConversationId = (id: string): void => {
    localStorage.setItem('current_conversation', id);
};

export const getCurrentConversationId = (): string | null => {
    return localStorage.getItem('current_conversation');
};

export const clearConversations = (): void => {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem('current_conversation');
}; 